import React from "react";
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import InputGroup from 'react-bootstrap/InputGroup'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Offcanvas from "react-bootstrap/Offcanvas";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import './index.css'
import { UserLogin, CreateUser, UserLoginGoogle, ForgotPassword, GetUser, UpdateUser, UserAcceptCookies } from '../../ApiRequests'
import { GoogleLogin } from '@react-oauth/google'
import { MdDirectionsBike } from 'react-icons/md'
import {GiConqueror} from 'react-icons/gi'
import Cookies from 'universal-cookie'
import jwtDecode from 'jwt-decode'
import Helmet from 'react-helmet'


const Login = (props) => {
    const navigate = useNavigate()
    const location = useLocation()
    const params = new URLSearchParams(location.search);
    const leagueId = params.get('leagueId')
    const leagueType = params.get('type')

    const [showCreateAccount, setShowCreateAccount] = useState(false)
    const [accountAlreadyExists, setAccountAlreadyExists] = useState(false)
    const [couldNotLogin, setCouldNotLogin] = useState(false)
    const [showLogin, setShowLogin] = useState(false)
    const [showForgotPassword, setShowForgotPassword] = useState(false)
    const [forgotPasswordModal, setForgotPasswordModal] = useState(false)
    const [signUpDisabled, setSignUpDisabled] = useState(false)
    const [signUpDisabledPassword, setSignUpDisabledPassword] = useState(false)
    const [signUpDisabledUsername, setSignUpDisabledUsername] = useState(false)
    const [userName, setUserName] = useState('')
    const [user, setUser] = useState({})
    const [confirmUserName, setConfirmUsername] = useState('')
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [forgotEmail, setForgotEmail] = useState('')
    const [message, setMessage] = useState('')
    const [showCookieAgreement, setShowCookieAgreement] = useState(false)
    const [token, setToken] = useState('')


    const gmailError = 'Please sign in with google if using gmail. Otherwise, duplicate accounts can be created...'
    const validUsernamePassword = 'Please enter a valid username and password. '

    const clearFields = () => {
        setUserName('')
        setPassword('')
    }

    const handleClickLogin = () => {
        setShowLogin(!showLogin)
        setShowCreateAccount(false)
        setPassword('')
        setUserName('')
    }

    const handleClickCreateAccount = () => {
        setShowLogin(false)
        setShowCreateAccount(!showCreateAccount)
        setPassword('')
        setUserName('')
    }

    const handleUserLoggedIn = () => {
        navigate('/')
    }

    const handleSignIn = async () => {
        if (password == '' || userName == '') return

        const response = await UserLogin(userName.trim(), password)
        console.log(response)
        try {
            if (response.data) {
                const _userID = await storeUserID(response.data.token)
                const _user = await GetUser(_userID)


                // if (_user && !_user.data?.acceptCookies) {
               
                //     setUser(_user.data)
                //     setShowCookieAgreement(true)
                //     setToken(response.data.token)
                //     return
                //     //store the response in a state variable, and do the rest after login
                // }


                await storeToken(response.data.token)
                props.handleLogin(_user.data, leagueId, leagueType)
            } else {
                console.log('could not sign in')
                clearFields()
                setCouldNotLogin(true)
            }
        } catch (err) {
            console.log('Could not sign in', err)
            clearFields()
            setCouldNotLogin(true)
        }

    }

    const NavigateHome = () => {
        navigate('/')
    }

    const handleSignUp = async () => {

        if (password == '' || userName == '') { setMessage(validUsernamePassword); return }

        const trimmedUsername = userName.trim()
        if (trimmedUsername.endsWith('@gmail.com') || trimmedUsername.endsWith('@gmail.ca')) { setMessage(gmailError); return }

        setSignUpDisabled(true)
        const data = {
            userName: trimmedUsername,
            password: password,
        }
        try {
            const response = await CreateUser(data)

            if (response && response.data) {

                const _userID = await storeUserID(response.data.token)
                const _user = await GetUser(_userID)

                //If user has not accepted cookies
                // if (_user && !_user.data?.acceptCookies) {
                //     setUser(_user.data)
                //     setShowCookieAgreement(true)
                //     setToken(response.data.token)
                //     return
                // }

                await storeToken(response.data.token)
                props.handleLogin(_user.data, leagueId, leagueType)
            } else {
                console.log('no response ')
                setSignUpDisabled(false)
            }
        } catch (err) {
            setSignUpDisabled(false)
            setAccountAlreadyExists(true)
        }

    }


    const responseGoogle = async (response) => {
        if (!response.credential) { return null }
        const result = await UserLoginGoogle(response.credential)
        if (result) {

            const _userID = await storeUserID(result.data.token)
            const _user = await GetUser(_userID)

            //If user has not accepted cookies
            // if (_user && !_user.data?.acceptCookies) {
            //     setUser(_user.data)
            //     setShowCookieAgreement(true)
            //     setToken(result.data.token)
            //     return
            // }

            await storeToken(result.data.token)
            props.handleLogin(_user.data, leagueId, leagueType)
        }
    };

    const handleAcceptCookies = async () => {
        //update user
        try {
            const res = await UserAcceptCookies(user._id)
            console.log(res)

            await storeToken(token)
            props.handleLogin(user, leagueId, leagueType)

        } catch (error) {
            console.log(error)
        }
    }

    const storeToken = async (_token) => {
        try {
            const cookies = new Cookies()
            cookies.set('jwt', _token, { path: '/' })
            return true
        } catch (err) {
            return false
        }
    }

    const storeUserID = async (_token) => {
        if (!_token) { return }
        const decodedToken = jwtDecode(_token)
        localStorage.setItem('userID', decodedToken.userID)
        localStorage.setItem('userName', decodedToken.userName)
        return decodedToken.userID
    }

    const handleResetPassword = async () => {
        setForgotPasswordModal(true)
        const res = await ForgotPassword(forgotEmail)
    }

    return (
        <div className="" style={{ paddingTop: '4rem', height: '100vh' }}>
            <Helmet>
                <title>Login - 2023 Downhill MTB Fantasy</title>
                <meta name="description" content="Login to your Downhill MTB Fantasy account. Join the excitement of the fantasy league and compete with other mountain biking enthusiasts." />
            </Helmet>
            <div className="container d-flex flex-row align-items-center justify-content-center " style={{ maxWidth: '500px' }}>
                <Card className="border-white text-white" style={{ width: '28rem', background: 'linear-gradient(to bottom right, rgba(0, 0, 0, 0.2), black)'}}>
                    <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                        {/* <Card.Title style={{ paddingTop: '25px' }} className="fs-4 fw-bold mb-1">Downhill Mountain Biking</Card.Title>
                        <Card.Subtitle className="mb-3  fw-light" style={{ paddingTop: '10px' }} > Fantasy League</Card.Subtitle> */}
                        <Card.Title style={{ paddingTop: '25px' }} className="fs-4 fw-bold mb-1"><MdDirectionsBike style={{transform: 'rotate(0deg)'}}/></Card.Title>
                        <Button className=' mb-3' variant={showLogin ? `outline-primary` : `primary`} style={{ marginTop: '25px', width:'52%' }} onClick={() => { handleClickLogin() }}>Login</Button>
                        <GoogleLogin
                            onSuccess={responseGoogle}
                            onError={() => { console.log('Login Failed'); }}
                            useOneTap
                        />
                        <div className="d-sm-none text-muted mt-3 text-center">Google Sign in does not work in Instagram Browser. </div>
                        <div className="d-sm-none text-muted mt-2 text-center">Triple dots top right of your screen > 'Open in system browser' </div>

                        {showLogin &&
                            <div className="w-100 d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '25px', paddingBottom: '25px' }}>
                                <hr className="w-100"></hr>

                                <div className="row w-50 pt-2 mb-1" style={{ height: '55px' }}>
                                    <Form.Control placeholder="Email" value={userName} className='bg-dark text-white' onChange={(e) => setUserName(e.target.value)} onClick={() => { setCouldNotLogin(false) }}></Form.Control>
                                </div>
                                <div className="row w-50 pt-2" style={{ height: '55px' }}>
                                    <Form.Control type='password' placeholder="Password" className='bg-dark text-white' value={password} onChange={(e) => setPassword(e.target.value)}></Form.Control>
                                </div>
                                <Button variant='primary' className="w-50" style={{ marginTop: '10px' }} onClick={() => { handleSignIn() }}>Sign in</Button>
                                {couldNotLogin && <div className="pt-2" style={{ color: 'red' }}>Could not login. Please try again. </div>}
                                <Button variant='link' className="mt-3" onClick={() => setShowForgotPassword(!showForgotPassword)}>Forgot your password?</Button>

                                {showForgotPassword && <div className="py-2">
                                    <Form.Control type="text" placeholder="Email" className='' style={{ height: '47px' }} value={forgotEmail} onChange={(e) => { setForgotEmail(e.target.value) }} />
                                    <Button variant='outline-primary' className="my-2 w-100" onClick={() => { handleResetPassword() }}>Reset Password</Button>
                                    <br />
                                </div>}
                                <hr className="w-100" style={{ marginTop: '30px' }}></hr>
                            </div>
                        }

                        <div className="" style={{ paddingTop: '15px' }}>or</div>
                        <Card.Link className="hover-pointer" onClick={() => { handleClickCreateAccount() }} style={{ paddingTop: '15px' }}>Create Account</Card.Link>
                        {showCreateAccount &&
                            <div className="w-100 d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '25px', paddingBottom: '25px' }}>
                                <hr className="w-100"></hr>
                                <div className="fw-light my-2">Please provide an email and password</div>
                                {/* <Form.Label className="text-start text-muted w-50 pt-3 pb-0 mb-0 ms-4">Email</Form.Label> */}
                                <div className="row w-50 mt-3" style={{ paddingBottom: '10px', height: '55px'}}>
                                    <Form.Control placeholder="Email" value={userName} className='bg-dark text-white' onChange={(e) => {
                                        setUserName(e.target.value);
                                        if (e.target.value.toLowerCase() != confirmUserName.toLowerCase()) {
                                            setMessage('Emails do not match')
                                            setSignUpDisabledUsername(true)
                                        } else {
                                            setMessage('')
                                            setSignUpDisabledUsername(false)
                                        }
                                    }}></Form.Control>
                                </div>
                                <div className="row w-50" style={{ paddingBottom: '10px', height: '55px' }}>
                                    <Form.Control placeholder="Confirm Email" className='bg-dark text-white' value={confirmUserName} onChange={(e) => {
                                        setConfirmUsername(e.target.value);
                                        if (e.target.value.toLowerCase() != userName.toLowerCase() && userName != '') {
                                            setMessage('Emails do not match')
                                            setSignUpDisabledUsername(true)
                                        } else {
                                            setMessage('')
                                            setSignUpDisabledUsername(false)
                                        }
                                    }}></Form.Control>
                                </div>
                                {/* <Form.Label className="text-start text-muted w-50 pt-2 pb-0 mb-0 ms-4">Password</Form.Label> */}
                                <div className="row w-50 mt-4" style={{ paddingBottom: '10px', height: '55px' }}>
                                    <Form.Control placeholder="Password" type='password' className='bg-dark text-white' value={password} onChange={(e) => {
                                        setPassword(e.target.value)
                                        if (e.target.value != confirmPassword.toLowerCase()) {
                                            setMessage('Passwords do not match')
                                            setSignUpDisabledPassword(true)
                                        } else {
                                            setMessage('')
                                            setSignUpDisabledPassword(false)
                                        }
                                    }}></Form.Control>
                                </div>
                                <div className="row w-50" style={{ paddingBottom: '10px', height: '55px' }}>
                                    <Form.Control placeholder="Confirm Password" className='bg-dark text-white' type='password' value={confirmPassword} onChange={(e) => {
                                        setConfirmPassword(e.target.value);
                                        if (e.target.value != password) {
                                            setMessage('Passwords do not match')
                                            setSignUpDisabledPassword(true)
                                        } else {
                                            setMessage('')
                                            setSignUpDisabledPassword(false)
                                        }
                                    }}></Form.Control>
                                </div>
                                <Button variant='outline-primary' className="w-50" disabled={(userName == '' || password == '' || signUpDisabled || signUpDisabledPassword || signUpDisabledUsername)} style={{ marginTop: '10px' }} onClick={() => { handleSignUp() }}>Sign Up</Button>
                                {accountAlreadyExists && <div className="pt-3 text-center ms-3 fw-light" style={{ color: 'red', textAlign: 'start' }}>Account Already Exists</div>}
                                {message != '' && <div className="pt-3 text-center ms-3 fw-light" style={{ color: 'red', textAlign: 'start' }}>{message}</div>}
                            </div>
                        }
                    </Card.Body>
                </Card>
            </div>

            <Modal show={forgotPasswordModal} onHide={() => setForgotPasswordModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Email sent.</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    An email has been sent to {forgotEmail} with instructions to reset your password. Make sure to check your junk folder.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setForgotPasswordModal(false)}>
                        Ok
                    </Button>
                </Modal.Footer>
            </Modal>
            <Offcanvas show={showCookieAgreement} onHide={() => setShowCookieAgreement(false)} placement='bottom' style={{ height: 'auto' }}>
                <Offcanvas.Header closeButton className="pb-0 ">
                    <Offcanvas.Title className=" w-100 ms-sm-4 pb-0 d-flex flex-row justify-content-center">This website requires Cookies. </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="pt-0" >
                    {window.innerWidth <= 767 ?
                        <>
                            <div className="row d-flex flex-row justify-content-center mt-3 mt-sm-0">
                                <div className="col-sm-2  ms-sm-4 ">
                                    <Button variant='primary' className='w-100' onClick={() => { setShowCookieAgreement(false) }}>Accept Cookies</Button>
                                </div>
                            </div>
                            <div className="ms-sm-4 pt-3 fw-light">
                                This website utilizes cookies to enable secure and encrypted authentication processes. These cookies are used to verify your identity and ensure that only authorized users can access sensitive information or perform certain actions.
                            </div>
                        </>
                        :
                        <>
                            <div className="ms-sm-4 pt-2 fw-light">
                                This website utilizes cookies to enable secure and encrypted authentication processes. These cookies are used to verify your identity and ensure that only authorized users can access sensitive information or perform certain actions.
                            </div>
                            <div className="row d-flex flex-row justify-content-center ">
                                <div className="col-sm-4 col-md-2 mt-3 ms-sm-4 me-4">
                                    <Button variant='primary' className='w-100' onClick={() => { handleAcceptCookies() }}>Accept Cookies</Button>
                                </div>
                            </div>
                        </>
                    }

                </Offcanvas.Body>
            </Offcanvas>
        </div >
    );
}

export default Login;